
 if (window.scrollY > 0) {
        document.body.classList.add("not-top");
    } else {
        document.body.classList.remove("not-top");
    }

// document.addEventListener("DOMContentLoaded", function () {

//     function checkScroll() {
//         if (window.scrollY > 0) {
//             document.body.classList.add("not-top");
//         } else {
//             document.body.classList.remove("not-top");
//         }
//     }

   
//     checkScroll();

   
//     window.addEventListener("scroll", checkScroll);

// });

// Footer: email signup success message hide after 5 seconds
document.addEventListener('DOMContentLoaded', function () {
  const successMsg = document.querySelector('footer  .email-signup__message');
  if (successMsg) {
    setTimeout(() => {
      successMsg.style.display = 'none';
      }, 5000); // 5 seconds
    }
  });


// wishlist count update after cart update event 
document.addEventListener('cart:update', (event) => {
  if (event.detail?.data?.didError) return;

  setTimeout(() => {
    const wishlist = document.querySelector('ydp-wishlist');
    if (wishlist?.rendercount) {
      wishlist.rendercount();
      console.log("wishlist", wishlist);
    }
  }, 300); // adjust delay to match your drawer animation
});


// document.addEventListener("DOMContentLoaded", () => {
//     const selectors = [
//         ".logo-block__image-wrapper",
//         ".header-logo",
//         ".header-menu"
//     ];

//     const getIsScrolled = () => window.scrollY > 0;

//     const applyScrollState = (element) => {
//         element.classList.toggle("scrolled", getIsScrolled());
//     };

//     const observeElement = (element) => {
//         const observer = new MutationObserver((mutations) => {
//             mutations.forEach((mutation) => {
//                 if (mutation.attributeName === "class") {
//                     const isScrolled = getIsScrolled();
//                     const hasScrolled = element.classList.contains("scrolled");

//                     // If it SHOULD have scrolled but DOESN'T — re-add it
//                     if (isScrolled && !hasScrolled) {
//                         // Temporarily disconnect to avoid infinite loop
//                         observer.disconnect();
//                         element.classList.add("scrolled");
//                         observer.observe(element, { attributes: true });
//                     }
//                 }
//             });
//         });

//         observer.observe(element, { attributes: true });
//     };

//     const init = () => {
//         const elements = selectors
//             .map(sel => document.querySelector(sel))
//             .filter(Boolean);

//         if (!elements.length) return;

//         elements.forEach(element => {
//             applyScrollState(element);
//             observeElement(element);
//         });

//         window.addEventListener("scroll", () => {
//             elements.forEach(applyScrollState);
//         }, { passive: true });
//     };

//     init();
// });

document.addEventListener("DOMContentLoaded", function () {

    const items = document.querySelectorAll(".menu-customer h4");
    let isInitialized = false;

    function initAccordion() {
        if (window.innerWidth < 750 && !isInitialized) {
            isInitialized = true;

            items.forEach((heading) => {
                const content = heading.nextElementSibling;
                if (!content) return;

                // initial state
                content.style.height = "0px";
                content.style.overflow = "hidden";
                content.style.transition = "height 0.3s ease";

                heading.onclick = function () {
                    const isOpen = heading.classList.contains("active");

                    // close all
                    items.forEach((otherHeading) => {
                        otherHeading.classList.remove("active", "highlighted");
                        const otherContent = otherHeading.nextElementSibling;
                        if (otherContent) otherContent.style.height = "0px";
                    });

                    // open current
                    if (!isOpen) {
                        heading.classList.add("active", "highlighted");
                        content.style.height = content.scrollHeight + "px";

                        setTimeout(() => {
                            heading.scrollIntoView({
                                behavior: "smooth",
                                block: "start"
                            });
                        }, 200);
                    }
                };
            });

            document.addEventListener("click", outsideClickHandler);
        }
    }

    function destroyAccordion() {
        if (window.innerWidth >= 750 && isInitialized) {
            isInitialized = false;

            items.forEach((heading) => {
                const content = heading.nextElementSibling;
                if (!content) return;

                heading.classList.remove("active", "highlighted");

                // reset styles
                content.style.height = "";
                content.style.overflow = "";
                content.style.transition = "";

                heading.onclick = null;
            });

            document.removeEventListener("click", outsideClickHandler);
        }
    }

    function outsideClickHandler(e) {
        if (!e.target.closest(".menu-customer")) {
            items.forEach((heading) => {
                heading.classList.remove("active", "highlighted");
                const content = heading.nextElementSibling;
                if (content) content.style.height = "0px";
            });
        }
    }

    function handleResize() {
        initAccordion();
        destroyAccordion();
    }

    // initial run
    handleResize();

    // on resize
    window.addEventListener("resize", handleResize);
});


// logo animation
// document.addEventListener("DOMContentLoaded", () => {
//   const bannerLogo = document.querySelector(".logo-block");
//   const headerLogo = document.querySelector(".header-logo");

//   if (!bannerLogo || !headerLogo) return;

//   let ticking = false;

//   function animateLogo() {

    
//     bannerLogo.style.transform = "translate3d(0,0,0) scale(1)";

//     const bannerRect = bannerLogo.getBoundingClientRect();
//     const headerRect = headerLogo.getBoundingClientRect();

//     const bannerX = bannerRect.left + bannerRect.width / 2;
//     const bannerY = bannerRect.top + bannerRect.height / 2;

//     const headerX = headerRect.left + headerRect.width / 2;
//     const headerY = headerRect.top + headerRect.height / 2;

//     const moveX = headerX - bannerX;
//     const moveY = headerY - bannerY;

//     const maxScroll = 300;
//     const progress = Math.min(window.scrollY / maxScroll, 1);

//     bannerLogo.style.transform = `
//       translate3d(${moveX * progress}px, ${moveY * progress}px, 0)
//       scale(${1 - progress * 0.4})
//     `;
//   }

//   function onScroll() {
//     if (!ticking) {
//       requestAnimationFrame(() => {
//         animateLogo();
//         ticking = false;
//       });

//       ticking = true;
//     }
//   }

//   animateLogo();

//   window.addEventListener("scroll", onScroll);
//   window.addEventListener("resize", animateLogo);
// });

// document.addEventListener("DOMContentLoaded", () => {

//   const bannerLogo = document.querySelector(".logo-block");
//   const headerLogo = document.querySelector(".header-logo");

//   if (!bannerLogo || !headerLogo) return;

//   const bannerRect = bannerLogo.getBoundingClientRect();
//   const headerRect = headerLogo.getBoundingClientRect();

//   const startScroll = 10;
//   const endScroll = 20;

//   let locked = false;

//   function animate() {

//     if (locked) return;

//     const scroll = window.scrollY;

//     let progress = 0;

//     if (scroll > startScroll) {
//       progress = Math.min(
//         (scroll - startScroll) / (endScroll - startScroll),
//         1
//       );
//     }

//     const ease = 1 - Math.pow(1 - progress, 3);

//     const moveX =
//       (headerRect.left + headerRect.width / 2) -
//       (bannerRect.left + bannerRect.width / 2);

//     const moveY =
//       (headerRect.top + headerRect.height / 2) -
//       (bannerRect.top + bannerRect.height / 2);

//     bannerLogo.style.transform = `
//       translate3d(${moveX * ease}px, ${moveY * ease}px, 0)
//       scale(${1 - ease * 1.2})
//     `;


//     if (progress >= 1) {

//       locked = true;

//       bannerLogo.style.position = "fixed";

//       bannerLogo.style.left =
//         `${headerRect.left + headerRect.width / 2 - bannerRect.width * 0.3}px` - 200;

//       bannerLogo.style.top =
//         `${headerRect.top + headerRect.height / 2 - bannerRect.height * 0.3}px`;

//       bannerLogo.style.transform = "translate3d(0,0,0) scale(0.6)";
//     }
//   }

//   function onScroll() {
//     requestAnimationFrame(animate);
//   }

//   bannerLogo.style.willChange = "transform";
//   bannerLogo.style.transformOrigin = "center center";

//   window.addEventListener("scroll", onScroll, { passive: true });

// });

// document.addEventListener("DOMContentLoaded", () => {

//   const shopBtn = document.querySelector(".block-button");
//   const headerLogo = document.querySelector(".header-logo__image-container--inverse");

//   if (!shopBtn || !headerLogo) return;

//   function setHeaderLogoPosition() {

//     const shopRect = shopBtn.getBoundingClientRect();
//     const logoRect = headerLogo.getBoundingClientRect();

//     // top distance
//     const top = shopRect.top;

//     // horizontal center
//     const left =
//       shopRect.left +
//       (shopRect.width / 2) -
//       (logoRect.width / 2);

//     headerLogo.style.position = "fixed";
//     headerLogo.style.top = `${top - 100}px`;
//     headerLogo.style.left = `${left}px`;

//   }

//   setHeaderLogoPosition();

//   window.addEventListener("resize", setHeaderLogoPosition);

// });

// Mobile drawer: toggle .drawer-open on #header-component when header-drawer opens/closes
(function () {
  const DRAWER_CLASS = 'menu-black-bg';
  let observer = null;

  function setupObserver() {
    const headerDrawer = document.querySelector('header-drawer');
    const header = document.querySelector('.header__row');

    if (!headerDrawer || !header) return;

    const detailsEl = headerDrawer.querySelector(
      '#Details-menu-drawer-container'
    );

    if (!detailsEl) return;

    observer = new MutationObserver(function () {
      const isOpen = detailsEl.classList.contains('menu-open');

      header.classList.toggle(DRAWER_CLASS, isOpen);
    });

    observer.observe(detailsEl, {
      attributes: true,
      attributeFilter: ['class'],
    });
  }

  customElements.whenDefined('header-drawer').then(setupObserver);
})();



 

